// These two enums were thrown together by looking at the existing Universal
// implementation.  We need to go back and make sure these values are complete
// and the correct:
// https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/141192
export enum GlobalCalendarType {
    Gregorian = 'Gregorian',
    Hebrew = 'Hebrew',
    Hijri = 'Hijri',
    UmmAlQuara = 'UmmAlQuara',
    SakaEra = 'SakaEra',
    JapaneseLunar = 'JapaneseLunar',
    Rokuyou = 'Rokuyou',
    JapaneseZodiac = 'JapaneseZodiac',
    ChineseLunar = 'ChineseLunar',
    ChineseZodiac = 'ChineseZodiac',
    Persian = 'Persian',
    ThaiBuddist = 'ThaiBuddist',
    KoreanLunar = 'KoreanLunar',
    KoreanZodiac = 'KoreanZodiac',
}

export enum GlobalCalendarLanguage {
    English = 'English',
    Japanese = 'Japanese',
    ChineseSimplified = 'ChineseSimplified',
    ChineseTraditional = 'ChineseTraditional',
    Arabic = 'Arabic',
    Persian = 'Persian',
    Thai = 'Thai',
    Korean = 'Korean',
    Hebrew = 'Hebrew',
    Hindi = 'Hindi',
}

export class GlobalCalendarLocale {
    constructor(calendarType: GlobalCalendarType, calendarLanguage: GlobalCalendarLanguage) {
        this._calendarType = calendarType;
        this._calendarLanguage = calendarLanguage;
    }

    get calendarType(): GlobalCalendarType {
        return this._calendarType;
    }

    get calendarLanguage(): GlobalCalendarLanguage {
        return this._calendarLanguage;
    }

    // Generate an IETF language tag.  The "u" indicates an extension and the "ca" indicates
    // that the extension is specifying the calendar type.
    toString(): string {
        return this._calendarLanguage + '-u-ca-' + this.calendarType;
    }

    _calendarType: GlobalCalendarType;
    _calendarLanguage: GlobalCalendarLanguage;
}
